import { useState } from "react";
import { subscribeInsetSet } from "../../api/subscribe";
import { failAlert, successAlert } from "../../common/alert";
import InquiryCompleteModal from "../elements/inquiryCompleteModal";
import * as News from "./newsletter.styles";
import Link from "next/link";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [openInquiryComplete, setOpenInquiryComplete] = useState(false);

  const onChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const onClickInquiryComplete = () => {
    setOpenInquiryComplete((prev) => !prev);
  };

  const subscribe = async () => {
    if (email == "") {
      failAlert("이메일을 입력해주세요.");
      return;
    }
    const body = {
      modes: "InsertSet",
      email: email,
    };
    const res = await subscribeInsetSet(body);
    if (res.Code === "0000") {
      onClickInquiryComplete();
      successAlert(res?.Data?.Msg || "구독 신청이 완료되었습니다.");
      setEmail("");
    } else {
      failAlert(res.Data?.Msg || "구독 신청에 실패했습니다.");
    }
  };

  return (
    <>
      <News.Container>
        <News.Section>
          <News.TextWrapper>
            <News.Heading>
              <span>칼렛스토어</span>
              와 함께하는 소식을 <br />
              놓치지 마세요
            </News.Heading>
          </News.TextWrapper>

          <News.SubscibeContainer>
            <News.SubscibeWrapper>
              <News.SubscibeInput
                onChange={onChangeEmail}
                type="text"
                placeholder="이메일 입력"
                value={email || ""}
              />
              <News.SubscibeButton onClick={subscribe}>
                소식 받아보기
              </News.SubscibeButton>
            </News.SubscibeWrapper>

            <News.Paragraph className={"font-sm"}>
              소식 전달을 목적으로 이름, 이메일 주소를 수집하며, 수신거부시까지
              이용 및 보유합니다.
            </News.Paragraph>
            <Link href={"/esg-guide/letter/"}>
              <p
                className={"font-sm"}
                style={{
                  fontWeight: "bold",
                  textDecoration: "underline",
                  color: "#3BB77E",
                  cursor: "pointer",
                }}
              >
                지난 뉴스레터 보기
              </p>
            </Link>
          </News.SubscibeContainer>
        </News.Section>
      </News.Container>

      {openInquiryComplete && (
        <InquiryCompleteModal onClickInquiryComplete={onClickInquiryComplete} />
      )}
    </>
  );
};
export default Newsletter;
